<app-header [icon]="'arrow_back_ios'" (iconClickedEvent)="back()"></app-header>
<div class="container">
  <div class="info-container">
    <div class="sub-title">
      {{'log_viewer.title' | translate}}{{logService.log().id}}
    </div>
    <div class="item user">
      <span>{{'log_viewer.registered_by' | translate}}</span>
      {{userFullName}}
    </div>
    <div class="divider"></div>
    <div class="item mood">
      <span>{{'log_viewer.mood' | translate}}</span>
      <div class="mood-row">
        <div class="mood-color" [class]="mood.class">
          <img [src]="mood.image" [alt]="mood.label" class="mood-icon">
        </div>
        {{logService.log().mood | translate}}
      </div>
    </div>
    <div class="divider"></div>
    <div class="item feelings">
      <span>{{'log_viewer.feelings' | translate}}</span>
      <div class="chip-container">
        @for (feeling of selectedFeelings(); track $index) {
          <div class="chip">{{feeling.label | translate}}</div>
        }
      </div>
    </div>
    <div class="divider"></div>
    <div class="item body-reactions">
      <span>{{'log_viewer.body_reactions' | translate}}</span>
      <div class="chip-container">
        @for (bodyReaction of selectedBodyReactions(); track $index) {
          <div class="chip">{{bodyReaction.label | translate}}</div>
        }
      </div>
    </div>
    <div class="divider"></div>
    <div class="item reasons">
      <span>{{'log_viewer.reasons' | translate}}</span>
      {{logService.log().what_happened}}
    </div>
    <div class="divider"></div>
    <div class="item did_think">
      <span>{{'log_viewer.thoughts' | translate}}</span>
      {{logService.log().did_think}}
    </div>
    <div class="divider"></div>
    <div class="item did_do">
      <span>{{'log_viewer.done' | translate}}</span>
      {{logService.log().did_do}}
    </div>
    <div class="divider"></div>
    <div class="item other_thought">
      <span>{{'log_viewer.other_thought' | translate}}</span>
      {{logService.log().other_thought}}
    </div>
  </div>
  <div class="actions-container">
    <app-button
      [buttonLabel]="'buttons.back' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR" 
      [buttonDisabled]="false"
      (click)="back()">
    </app-button>
  </div>
</div>
